import { render, staticRenderFns } from "./FooterCopyrightPreview.vue?vue&type=template&id=2dd5a449&scoped=true"
import script from "./FooterCopyrightPreview.vue?vue&type=script&lang=js"
export * from "./FooterCopyrightPreview.vue?vue&type=script&lang=js"
import style0 from "./FooterCopyrightPreview.vue?vue&type=style&index=0&id=2dd5a449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd5a449",
  null
  
)

export default component.exports